import React from "react";

// Grundfarben der UNEQ-Typen (gleiche Werte wie die benefit-type-Markierungen).
export const FARBTYP_COLORS = { rot: "#e74c3c", gelb: "#f1c40f", gruen: "#2ecc71", blau: "#3498db" };

// Zwei Farbpunkte für einen Farbtyp-Key ("blau-rot" → blau + rot). Macht den Typ
// auf einen Blick erkennbar, ohne Text.
export function FarbtypDots({ value }) {
  const parts = (value || "").toLowerCase().split("-").filter(Boolean);
  return (
    <span className="farbtyp-dots" aria-hidden="true">
      {parts.map((p, i) => (
        <span key={i} className="farbtyp-dot" style={{ background: FARBTYP_COLORS[p] || "#888" }} />
      ))}
    </span>
  );
}
